angular.module('MW.InsDashboard.SocialReachWidget.BarChartDataFormatter', [
    'MW.InsDashboard.SocialReachWidget.SocialReachChartDataFormattingService',
    'MW.InsDashboard.SocialReachWidget.SocialReachTooltipRenderer',
    'MW.Framework.TranslationService',
    'MW.InsDashboard.InsWidgetConfigService',
    'MW.Framework.CoreUserService',
])
.factory('BarChartTooltipHandler', [
    'SocialReachChartDataFormattingService',
    'SocialReachTooltipOptions',
    'SocialReachTooltipRenderer',
    '$log',
function (SocialReachChartDataFormattingService, SocialReachTooltipOptions, SocialReachTooltipRenderer, $log) {
    'use strict';

    return {
        createBarChartTooltipHandler: function (dateFrom, dateTo, search) {
            return function barChartTooltipHandler (event){
                var currentSource,
                    xAxisIndex,
                    firstSeriesIndexOfTheHoveredDay,
                    hoveredSeries,
                    seriesPointForDayIndex,
                    seriesPointsForDay,
                    sourceCount,
                    sourceName,
                    sourcePercentage,
                    tooltipOptions = {},
                    total;

                total = 0;

                hoveredSeries = this.series;
                firstSeriesIndexOfTheHoveredDay = event.chart.series.indexOf(hoveredSeries);
                xAxisIndex = event.chart.series[firstSeriesIndexOfTheHoveredDay].xData[0];
                seriesPointsForDay = event.chart.series.filter(function (x) {
                    return x.xData[0] === xAxisIndex;
                });


                for (seriesPointForDayIndex = 0; seriesPointForDayIndex < seriesPointsForDay.length; seriesPointForDayIndex++) {
                    currentSource = seriesPointsForDay[seriesPointForDayIndex];
                    sourceCount = parseInt(currentSource.points[0].count);
                    sourceName = currentSource.name;
                    sourcePercentage = currentSource.points[0].perc;

                    switch (sourceName) {
                        case SocialReachChartDataFormattingService.sourceSettings.Facebook.id:
                            tooltipOptions.facebookCount = sourceCount;
                            tooltipOptions.facebookPercentage = sourcePercentage;
                            break;
                        case SocialReachChartDataFormattingService.sourceSettings.Twitter.id:
                            tooltipOptions.twitterCount = sourceCount;
                            tooltipOptions.twitterPercentage = sourcePercentage;
                            break;
                        case SocialReachChartDataFormattingService.sourceSettings.YouTube.id:
                            tooltipOptions.youTubeCount = sourceCount;
                            tooltipOptions.youTubePercentage = sourcePercentage;
                            break;
                        default:
                            $log.error('Unable to handle tooltip for unknown social source name in series: ' + sourceName);
                            throw new Error('Unknown social source: ' + sourceName);
                    }

                    total += sourceCount;
                }

                tooltipOptions.totalCount = total;

                if (xAxisIndex > 0) {
                    tooltipOptions.change = hoveredSeries.points[0].change;
                    tooltipOptions.showChange = true;
                }

                tooltipOptions.searchName = search;
                tooltipOptions.dateFrom = dateFrom;
                tooltipOptions.dateTo = dateTo;

                return SocialReachTooltipRenderer.render(new SocialReachTooltipOptions(tooltipOptions));
            };
        }
    };
}])
.service('BarChartDataFormatter', [
    'BarChartTooltipHandler',
    'SocialReachChartDataFormattingService',
    'translationService',
    'InsWidgetConfigService',
    'CoreUserService',
    function (BarChartTooltipHandler, SocialReachChartDataFormattingService, translationService, InsWidgetConfigService, CoreUserService) {
        'use strict';
        return {
            calculateDay: function (settings, individualTotal, index, date, total, totalChange, percentageMode) {
                var dataPoint = SocialReachChartDataFormattingService.calculateDataPoint(settings, individualTotal, index, date, total, totalChange, percentageMode);
                if (!dataPoint)
                    return;

                return {
                    name: settings.name,
                    data: [
                        dataPoint
                    ],
                    showInLegend: false,
                    linkedTo: settings.id
                };
            },
            formatChartData: function formatChartData(scope, socialReachData, dateStart, dateEnd, granularity) {
                var change,
                    chartType,
                    chartScale,
                    dateCategories,
                    dayArray,
                    epochMoment,
                    facebookDay,
                    index,
                    percentageMode,
                    previousTotal,
                    seriesArray,
                    tickPositions,
                    timezone,
                    tooltipHandler,
                    total,
                    totalFacebookCount,
                    totalTwitterCount,
                    totalYoutubeCount,
                    twitterDay,
                    youTubeDay;

                percentageMode = scope.widget.settings.chart.percentageMode;
                chartScale = scope.widget.getChartScaleProperty();
                chartType = SocialReachChartDataFormattingService.getChartType(percentageMode, chartScale);
                dateCategories = SocialReachChartDataFormattingService.getDateCategories(socialReachData.data.views.yt_views.statistics, dateStart, dateEnd, granularity);
                dayArray = [];
                index = 0;
                previousTotal = 0;
                seriesArray = [];
                tickPositions = SocialReachChartDataFormattingService.createTickPositions(socialReachData.data.views.yt_views.statistics);
                timezone = CoreUserService.getTimezone();

                for (var epoch in socialReachData.data.views.yt_views.statistics) {
                    if(!socialReachData.data.views.yt_views.statistics.hasOwnProperty(epoch)) {
                        continue;
                    }
                    totalFacebookCount = socialReachData.data.views.fb_totals.statistics[epoch].SUM;
                    totalTwitterCount = socialReachData.data.views.tw_followers.statistics[epoch].SUM;
                    totalYoutubeCount = socialReachData.data.views.yt_views.statistics[epoch].SUM;
                    total = (totalFacebookCount + totalTwitterCount + totalYoutubeCount);

                    change = SocialReachChartDataFormattingService.calculateChange(previousTotal, total);
                    epochMoment = moment(parseInt(epoch)).tz(timezone);

                    youTubeDay = this.calculateDay(SocialReachChartDataFormattingService.sourceSettings.YouTube, totalYoutubeCount, index, epochMoment, total, change, percentageMode);
                    twitterDay = this.calculateDay(SocialReachChartDataFormattingService.sourceSettings.Twitter, totalTwitterCount, index, epochMoment, total, change, percentageMode);
                    facebookDay = this.calculateDay(SocialReachChartDataFormattingService.sourceSettings.Facebook, totalFacebookCount, index, epochMoment, total, change, percentageMode);

                    if(youTubeDay) {
                        dayArray.push(youTubeDay);
                    }
                    if(twitterDay) {
                        dayArray.push(twitterDay);
                    }
                    if(facebookDay) {
                        dayArray.push(facebookDay);
                    }

                    // sort each day so the source with the lowest reach appears closest to the bottom
                    dayArray.sort(function (left, right) {
                        return parseFloat(right.data[0].y || 0) - parseFloat(left.data[0].y || 0);
                    });

                    seriesArray = seriesArray.concat(dayArray);

                    previousTotal = total;
                    dayArray = [];
                    index++;
                }

                seriesArray = seriesArray.concat([
                    SocialReachChartDataFormattingService.sourceSettings.YouTube,
                    SocialReachChartDataFormattingService.sourceSettings.Twitter,
                    SocialReachChartDataFormattingService.sourceSettings.Facebook
                ]);

                tooltipHandler = BarChartTooltipHandler.createBarChartTooltipHandler(
                    dateStart,
                    dateEnd,
                    scope.inputs[0].name);

                return {
                    credits: {
                        enabled: false
                    },
                    exporting: {
                        enabled: false
                    },
                    title: {
                        text: null
                    },
                    chart: {
                        zoomType: '',
                        spacingLeft: 0,
                        marginRight: 1,
                        type: 'column'
                    },
                    tooltip: {
                        borderRadius: 4,
                        backgroundColor: 'rgba(255,255,255,.85)',
                        hideDelay: 0,
                        formatter: tooltipHandler
                    },
                    xAxis: [
                        {
                            max: tickPositions.length - 1,
                            min: 0,
                            lineColor: '#eee',
                            tickColor: '#eee',
                            startOnTick: false,
                            tickmarkPlacement: 'on',
                            type: 'category',
                            categories: dateCategories,
                            minPadding: 0,
                            tickLength: 5,
                            labels: {
                                y: 14,
                                enabled: false
                            }
                        },
                        {
                            max: tickPositions.length - 1,
                            min: 0,
                            lineWidth: 0,
                            type: 'category',
                            tickColor: '#ffffff',
                            tickPositions: !scope.isMaximized ? [0, tickPositions.length - 1] : tickPositions,
                            tickLength: 5,
                            categories: dateCategories,
                            linkedTo: 0,
                            labels: {
                                y: 14,
                                overflow: 'justify',
                                style: {
                                    color: '#888',
                                    font: '11px "Helvetica Neue", Verdana, sans-serif',
                                    fontWeight: '500'
                                }
                            }
                        }
                    ],
                    yAxis: {
                        min: (!percentageMode) ? 1 : null,
                        max: (percentageMode) ? 100 : null,
                        type: chartType,
                        lineColor: '#eee',
                        lineWidth: 1,
                        minorTickInterval: 0.01,
                        title: {
                            text: percentageMode ?
                                translationService.getLocalizedString('Percentage') :
                                translationService.getLocalizedString('social-reach-widget__graph-yaxis--reach')
                        },
                        gridLineColor: '#eee',
                        labels: {
                            formatter: function () {
                                if(percentageMode) {
                                    return SocialReachChartDataFormattingService.formatPercentageDataLabels(this.value);
                                } else {
                                    return SocialReachChartDataFormattingService.formatYAxisDataLabels(this.value);
                                }
                            }
                        },
                        stackLabels: {
                            enabled: SocialReachChartDataFormattingService.areTotalsLabelsVisible(scope.labelVisibility, percentageMode),
                            formatter: function () {
                                return SocialReachChartDataFormattingService.formatFixedPrecisionDataLabels(this.total, scope.isMaximized);
                            },
                            style: {
                                color: '#000',
                                textShadow: '-1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff'
                            }
                        }
                    },
                    plotOptions: {
                        series: {
                            cursor: 'pointer',
                            marker: {
                                symbol: 'circle',
                                radius: 5,
                                lineWidth: 0,
                                lineColor: '#ffffff'
                            },
                            states: {
                                hover: {
                                    halo: null
                                }
                            },
                            dataLabels: {
                                style: {
                                    color: '#000'
                                },
                                enabled: scope.labelVisibility,
                                formatter: function () {
                                    if (percentageMode) {
                                        return SocialReachChartDataFormattingService.formatPercentageDataLabels(this.point.perc);
                                    } else {
                                        return SocialReachChartDataFormattingService.formatFixedPrecisionDataLabels(this.point.count, scope.isMaximized);
                                    }
                                }
                            },
                            animation: InsWidgetConfigService.getChartAnimationStatus(scope.widget.id + scope.isMaximized),
                            point: {
                                events: {
                                    click: function () {
                                        scope.documentRequest.source = this.source;
                                        if (typeof scope.inputs !== 'undefined') {
                                            scope.internalDrillDown(scope.inputs[0].id, this.date);
                                        } else {
                                            scope.internalDrillDown(scope.searches[0].agent, this.date);
                                        }
                                    }
                                }
                            },
                            stacking: scope.graphType === 'column' ? 'normal' : null
                        }
                    },
                    legend: {
                        enabled: true,
                        borderRadius: 0,
                        borderWidth: 0,
                        symbolPadding: 3,
                        symbolWidth: 8,
                        symbolRadius: 0,
                        itemDistance: 20,
                        margin: 0,
                        x: 12,
                        y: 12,
                        padding: 0,
                        itemStyle: {
                            color: '#808080',
                            fontSize: '11px',
                            fontWeight: 'normal'
                        },
                        itemHoverStyle: {
                            color: '#808080'
                        }
                    },
                    series: seriesArray
                }
            }
        };
    }]);
